function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import CollapseBase from '../CollapseBase/CollapseBase';
import debounce from 'lodash.debounce';
import "./MoreOrLess.css";

var MoreOrLess = /*#__PURE__*/function (_Component) {
  _inheritsLoose(MoreOrLess, _Component);

  function MoreOrLess(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.setToggleTextNeeded = function () {
      var contentHeight = _this.containerBase.container.scrollHeight;

      if (_this.getCompactHeight() > contentHeight) {
        _this.setState({
          isToggleTextNeeded: false
        });
      }

      if (_this.getCompactHeight() < contentHeight) {
        _this.setState({
          isToggleTextNeeded: true
        });
      }
    };

    _this.handleClick = function (e) {
      e.preventDefault();
      var isExpanded = !_this.state.isExpanded;

      _this.setState({
        isExpanded: isExpanded
      });

      if (!isExpanded && _this.containerBase.container.getBoundingClientRect().top < 0) {
        _this.containerBase.container.scrollIntoView({
          block: 'start',
          behavior: 'smooth'
        });
      }

      _this.props.onExpandedChange(isExpanded);
    };

    _this.debounceHandler = debounce(_this.setToggleTextNeeded, 100);
    _this.state = {
      isExpanded: _this.props.expanded,
      isToggleTextNeeded: true
    };
    return _this;
  }

  var _proto = MoreOrLess.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.componentDidMountTimer = setTimeout(function () {
      _this2.setToggleTextNeeded();
    }, 100);
    this.addListeners();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.expanded !== prevProps.expanded) {
      this.setState({
        // eslint-disable-line
        isExpanded: this.props.expanded
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.componentDidMountTimer) {
      clearTimeout(this.componentDidMountTimer);
    }

    this.detachListeners();
  };

  _proto.getCompactHeight = function getCompactHeight() {
    return this.containerBase.getCompactHeight();
  };

  _proto.addListeners = function addListeners() {
    window.addEventListener('resize', this.debounceHandler);
  };

  _proto.detachListeners = function detachListeners() {
    this.debounceHandler.cancel();
    window.removeEventListener('resize', this.debounceHandler);
  };

  _proto.render = function render() {
    var _this3 = this;

    /* eslint-disable no-unused-vars */
    // Extracting expanded and onExpandedChange so they aren't included in ...rest
    var _this$props = this.props,
        id = _this$props.id,
        moreText = _this$props.moreText,
        lessText = _this$props.lessText,
        lines = _this$props.lines,
        children = _this$props.children,
        className = _this$props.className,
        expanded = _this$props.expanded,
        paddingBottom = _this$props.paddingBottom,
        lineHeight = _this$props.lineHeight,
        onExpandedChange = _this$props.onExpandedChange,
        expanderPosition = _this$props.expanderPosition,
        rest = _objectWithoutProperties(_this$props, ["id", "moreText", "lessText", "lines", "children", "className", "expanded", "paddingBottom", "lineHeight", "onExpandedChange", "expanderPosition"]);
    /* eslint-enable no-unused-vars */


    var _this$state = this.state,
        isExpanded = _this$state.isExpanded,
        isToggleTextNeeded = _this$state.isToggleTextNeeded;
    var toggleText = isExpanded ? lessText : moreText;
    var isTopLeft = expanderPosition === 'top-left';
    var isTopRight = expanderPosition === 'top-right';
    var isBottomLeft = expanderPosition === 'bottom-left';
    var isBottomRight = expanderPosition === 'bottom-right';
    var isInlineInside = expanderPosition === 'inline';
    var isInlineOutside = isTopLeft || isTopRight || isBottomLeft || isBottomRight;
    var isBlock = expanderPosition === 'block' || !isInlineInside && !isInlineOutside;
    var divClassName = classNames(className, {
      MoreOrLess: true,
      'MoreOrLess--block': isBlock && isToggleTextNeeded,
      'MoreOrLess--inline-inside': isInlineInside,
      'MoreOrLess--inline-outside': isInlineOutside
    });
    var toggleClassName = classNames('text-link', {
      MoreOrLess__toggle: true,
      'MoreOrLess__toggle--block': isBlock,
      'MoreOrLess__toggle--block-expanded': isExpanded && isBlock,
      'MoreOrLess__toggle--top-left': isTopLeft,
      'MoreOrLess__toggle--top-right': isTopRight,
      'MoreOrLess__toggle--bottom-left': isBottomLeft,
      'MoreOrLess__toggle--bottom-right': isBottomRight,
      'MoreOrLess__toggle--inline-inside': isInlineInside,
      'MoreOrLess__toggle--inline-outside': isInlineOutside
    });
    var collapseBaseClassName = classNames({
      'MoreOrLess__CollapseBase--padding': isInlineInside
    });
    return /*#__PURE__*/React.createElement("div", _extends({
      id: id,
      className: divClassName
    }, rest, {
      ref:
      /* istanbul ignore next */
      function ref(c) {
        _this3.container = c;
      }
    }), /*#__PURE__*/React.createElement(CollapseBase, {
      className: collapseBaseClassName,
      expanded: isExpanded,
      lines: lines,
      lineHeight: lineHeight,
      paddingBottom: paddingBottom,
      ref: function ref(base) {
        _this3.containerBase = base;
      }
    }, children), isToggleTextNeeded && /*#__PURE__*/React.createElement("button", {
      "aria-expanded": isExpanded,
      "aria-controls": id,
      onClick: this.handleClick,
      className: toggleClassName
    }, /*#__PURE__*/React.createElement("span", {
      className: "MoreOrLess__toggle-text"
    }, toggleText)));
  };

  return MoreOrLess;
}(Component);

MoreOrLess.propTypes = {
  /** id tag for Component. Required for assistive devices (a11y) */
  id: PropTypes.string.isRequired,

  /** Flag to determine if the component is expanded or not on mount */
  expanded: PropTypes.bool,

  /** Total number of line rows (ems) to display when compact */
  lines: PropTypes.number,

  /** Expand button text; Can be a string, element, or component */
  moreText: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.func]).isRequired,

  /** Compact button text; Can be a string, element, or component */
  lessText: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.func]).isRequired,

  /** Optional event handler to trigger when the component expands or collapses.  Passes the isExpanded boolean as a parameter */
  onExpandedChange: PropTypes.func,

  /** The CSS line-height of the content, used to calculate how many rows to display. You will likely not need to adjust this. */
  lineHeight: PropTypes.number,

  /** The CSS padding-bottom of the MoreOrLess container; used to calculate expanded and collapsed height. You will likely not need to adjust this. */
  paddingBottom: PropTypes.number,

  /** Change position of more/less text. Options: top-left | top-right | bottom-left | bottom-right | inline | block */
  expanderPosition: PropTypes.oneOf(['top-left', 'top-right', 'bottom-left', 'bottom-right', 'inline', 'block'])
};
MoreOrLess.defaultProps = {
  expanded: false,
  lines: 6,
  lineHeight: 24,
  paddingBottom: 50,
  moreText: 'More',
  lessText: 'Less',
  onExpandedChange: function onExpandedChange() {},
  expanderPosition: 'block'
};
export default MoreOrLess;
//# sourceMappingURL=MoreOrLess.js.map